module.exports = __webpack_public_path__ + "static/img/blue01.402865c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/modularMain/blue01.png
// module id = Xw/y
// module chunks = 31